module.exports = __webpack_public_path__ + "media/ab-homepage/integrate-2908931b.png";